import { approachOptions } from 'components/forms/onboardingInputs/workHistory/data';
import _ from 'lodash';
import { GEOGRAPHIES_LOAD_SUCCESS, GEOGRAPHY_OPTIONS_LOAD_SUCCESS } from '../geographies/types';
import * as types from './types';
import cloneDeep from 'lodash/cloneDeep';
import { snakeCase } from 'snake-case';

const generateBenefits = () => [
  {
    value: 'Immediate/Next-day access to earnings',
    label: 'Immediate/Next-day access to earnings',
  },
  {
    value: 'Fully paid medical health insurance',
    label: 'Fully paid medical health insurance',
  },
  {
    value: 'Partially-paid medical health insurance',
    label: 'Partially-paid medical health insurance',
  },
  { value: 'Dental insurance', label: 'Dental insurance' },
  { value: 'Vision insurance', label: 'Vision insurance' },
  { value: 'Paid time off', label: 'Paid time off' },
  { value: 'Sick days', label: 'Sick days' },
  { value: '401(k)', label: '401(k)' },
  { value: '401(k) matching', label: '401(k) matching' },
  { value: 'Employee discount for childcare', label: 'Employee discount for childcare' },
  { value: 'Tuition reimbursement', label: 'Tuition reimbursement' },
  { value: 'Professional career development', label: 'Professional career development' },
  {
    value: 'Funding for NY State Teaching Certification',
    label: 'Funding for NY State Teaching Certification',
  },
  {
    value: 'Funding for Child Development Credential (CDA)',
    label: 'Funding for Child Development Credential (CDA)',
  },
  { value: 'Parental leave', label: 'Parental leave' },
  { value: 'Paid professional development days', label: 'Paid professional development days' },
  { value: 'Bonus or incentive program', label: 'Bonus or incentive program' },
];

export const filters = [
  {
    id: 'query',
    name: 'Text Search',
    type: 'text',
    value: '',
    placeholder: 'Job title or keyword...',
  },
  {
    id: 'minimumWage',
    name: 'Minimum compensation ($/hour)',
    type: 'range',
    value: 0,
  },
  {
    id: 'geography_id',
    key: 'geography_id',
    name: 'Location',
    type: 'hidden',
    isGeography: true,
    value: 'all',
  },
  {
    id: 'employment_type',
    name: 'Desired Schedule',
    type: 'checkbox',
    options: [
      { value: 'Full-Time', label: 'Full Time', checked: false },
      { value: 'Part-Time', label: 'Part Time', checked: false },
      { value: 'Seasonal', label: 'Seasonal', checked: false },
      { value: 'Substitute', label: 'Substitute', checked: false },
    ],
  },
  {
    id: 'role_type',
    name: 'Job Title',
    type: 'checkbox',
    options: [
      { label: 'Teacher (Lead/Head)', value: 'Teacher (Lead/Head)', checked: false },
      { label: 'Assistant Teacher', value: 'Assistant Teacher', checked: false },
      { label: 'Floater / Support Staff', value: 'Floater / Support Staff', checked: false },
      { label: 'Director', value: 'Director', checked: false },
      {
        label: 'Special Needs Teacher (Lead/Head)',
        value: 'Special Needs Teacher (Lead/Head)',
        checked: false,
      },
      {
        label: 'Special Needs Assistant Teacher',
        value: 'Special Needs Assistant Teacher',
        checked: false,
      },
    ],
  },
  {
    id: 'education_requirement',
    name: 'Minimum Education Requirement',
    type: 'checkbox',
    options: [
      { label: 'High School Diploma or equivalent', value: 'high_school', checked: false },
      { label: 'Associate Degree (in progress or completed)', value: 'associates', checked: false },
      { label: "Bachelor's Degree (in progress or completed)", value: 'bachelors', checked: false },
      { label: "Master's Degree (in progress or completed)", value: 'masters', checked: false },
    ],
  },
  {
    id: 'age_group',
    name: 'Age Group',
    type: 'checkbox',
    options: [
      { value: 'Infant', checked: false, label: 'Infant' },
      { value: 'Toddler', checked: false, label: 'Toddler' },
      { value: "3's", checked: false, label: "3's" },
      { value: "4's", checked: false, label: "4's" },
      { value: 'Pre-K', checked: false, label: 'Pre-K' },
      { value: 'Kindergarten', checked: false, label: 'Kindergarten' },
      { value: '1st grade', checked: false, label: '1st grade' },
      { value: '2nd grade', checked: false, label: '2nd grade' },
    ],
  },
  {
    id: 'education_philosophy',
    name: 'Education Philosophy',
    type: 'checkbox',
    options: approachOptions,
  },
  {
    id: 'requiredAdditionalBenefits',
    name: 'Required benefits',
    type: 'checkbox',
    options: generateBenefits(),
  },
];

const initialState = {
  initialized: false,
  loading: false,
  loadingOne: false,
  jobs: [],
  filters,
  filtersSearched: false,
  showJobFilter: null,
  sortJob: null,
  job: {},
};

const defaultizeFilters = (filters) => {
  filters.forEach((filter) => {
    if (filter.type === 'checkbox') {
      filter.options.forEach((option) => {
        option.checked = false;
      });
    } else if (filter.id === 'geography_id') {
      filter.value = 'all';
    } else {
      filter.value = '';
    }
  });

  return filters;
};

const jobReducer = (state = _.cloneDeep(initialState), { type, payload, error }) => {
  switch (type) {
    case types.JOBS_FETCH_PENDING:
      return {
        ...state,
        loading: true,
        initialized: true,
      };

    case types.JOBS_FETCH_FULFILLED:
      const newState = { ...state, jobs: payload.jobs, loading: false };
      if (payload.pagination) {
        return {
          ...newState,
          nextPage: payload.pagination.next_page,
          totalPages: payload.pagination.total_pages,
          currentPage: payload.pagination.current_page,
        };
      }
      return newState;
    case types.JOBS_FETCH_REJECTED:
      if (error?.name === 'AbortError') {
        return state;
      }
      console.error('Error running request', error);
      return {
        ...state,
        loading: false,
      };
    case types.JOB_SEARCH_FILTER_FROM_URL:
      const filtersFromUrl = state.filters.map((filter) => {
        if (Object.keys(payload).includes(filter.id)) {
          if (filter.type === 'checkbox') {
            return {
              ...filter,
              options: filter.options.map((option) => {
                const val = filter.isGeography ? option.label : option.value;
                if (payload[filter.id].includes(val)) {
                  return {
                    ...option,
                    checked: true,
                  };
                }
                return option;
              }),
            };
          }
          if (filter.type === 'range') {
            payload[filter.id] = +payload[filter.id] === 0 ? undefined : +payload[filter.id];
          }
          return {
            ...filter,
            value: payload[filter.id],
          };
        }

        return filter;
      });

      return {
        ...state,
        filters: filtersFromUrl,
      };
    case types.JOB_SEARCH_APPLY_SAVED_FILTER: {
      const defaultFilters = defaultizeFilters(cloneDeep(state.filters));

      function updateOptions(filterKey, savedData, defaultFilters) {
        const options = defaultFilters.find((filter) => filter.id === filterKey).options;
        options.forEach((option) => {
          if (savedData.includes(option.value)) {
            option.checked = true;
          }
        });
      }

      const savedFilter = payload;
      Object.entries(savedFilter.data).forEach(([k, v]) => {
        const filterKey = snakeCase(k);

        switch (filterKey) {
          case 'minimum_wage':
            const minWageFilter = defaultFilters.find((filter) => filter.id === 'minimumWage');
            minWageFilter.value = v;
            break;
          case 'geography_id':
            const geoFilter = defaultFilters.find((filter) => filter.id === filterKey);
            const geoOptions = defaultFilters.find((filter) => filter.id === filterKey).options;
            geoOptions.forEach((option) => {
              if (savedFilter.data[k] === option.value) {
                option.checked = true;
              }
            });
            break;
          case 'employment_type':
          case 'role_type':
          case 'education_requirement':
          case 'age_group':
          case 'education_philosophy':
          case 'covid_vaccine':
          case 'required_additional_benefits':
            if (filterKey === 'required_additional_benefits') {
              updateOptions('requiredAdditionalBenefits', savedFilter.data[k], defaultFilters);
            } else {
              updateOptions(filterKey, savedFilter.data[k], defaultFilters);
            }
            break;
        }
      });

      return {
        ...state,
        filters: defaultFilters,
      };
    }
    case types.JOB_SEARCH_CHANGE_FILTER:
      const filters = [...state.filters];
      const section = filters.find((filter) => filter.id === payload.section.id);
      let { option } = payload;

      switch (section.type) {
        case 'checkbox':
          option = section.options.find((option) => option.value === payload.option.value);
          option.checked = !option.checked;
          break;
        case 'text':
        case 'range':
        default:
          section.value = option;
      }

      return {
        ...state,
        filters,
        filtersSearched: false,
      };
    case types.JOB_SEARCH_RESET_FILTER: {
      const filters = [...state.filters];
      filters.forEach((filter) => {
        if (filter.type === 'checkbox') {
          filter.options.forEach((option) => {
            option.checked = false;
          });
        } else {
          const initialValue = initialState.filters.find((f) => f.id === filter.id)?.value;
          filter.value = initialValue || '';
        }
      });
      return {
        ...state,
        filters,
        filtersSearched: false,
      };
    }
    case types.JOB_SEARCH_ONE_LOAD_START:
      return {
        ...state,
        loadingOne: true,
      };
    case types.JOB_SEARCH_ONE_LOAD_SUCCESS:
      const job = state.job;
      job[payload.slug] = payload;
      return {
        ...state,
        job,
        loadingOne: false,
      };
    case types.JOB_SEARCH_ONE_LOAD_FAILURE:
      return {
        ...state,
        loadingOne: false,
      };
    case GEOGRAPHIES_LOAD_SUCCESS: {
      const activeGeographies = payload
        .filter((geography) => geography.userProfileRegisterable)
        .map((geography) => ({ value: geography.id, label: geography.longName }));

      const geoFilter = state.filters.find(({ isGeography }) => isGeography);
      geoFilter.options = _.sortBy(activeGeographies, ['label']);

      return {
        ...state,
        filters: [...state.filters],
      };
    }
    case GEOGRAPHY_OPTIONS_LOAD_SUCCESS: {
      // Create a copy of the current filters
      const updatedFilters = _.cloneDeep(state.filters);

      // Helper function to update filter options based on category
      const updateFilterOptions = (filterId, category) => {
        const filter = updatedFilters.find((filter) => filter.id === filterId);

        if (filter && payload) {
          const options = _.uniqBy(
            payload.filter((item) => item.category === category),
            'title',
          ).map((item) => ({
            value: item.title,
            label: item.title,
          }));

          if (options.length > 0) {
            filter.options = options;
          }
        }
      };

      // Update education philosophy options
      updateFilterOptions('education_philosophy', 'filterable_education_philosophy');

      // Update benefits options
      updateFilterOptions('requiredAdditionalBenefits', 'benefits');

      return { ...state, filters: updatedFilters };
    }

    case types.INITIALIZE_GEOGRAPHY: {
      const geoId = payload;
      const filters = _.cloneDeep(state.filters);
      const geoFilter = filters.find(({ isGeography }) => isGeography);
      const geoFilterOption = geoFilter?.options.find((opt) => opt.value === geoId);
      geoFilterOption && (geoFilterOption.checked = true);

      return {
        ...state,
        filters,
      };
    }

    case types.SET_SHOW_FILTER: {
      return {
        ...state,
        showJobFilter: payload,
      };
    }
    case types.SET_SORT: {
      return {
        ...state,
        sortJob: payload,
      };
    }

    case types.MARK_FILTER_AS_SEARCHED: {
      return {
        ...state,
        filtersSearched: true,
      };
    }

    default:
      return state;
  }
};

export default jobReducer;
